import { BODY_CLASS_SCROLL_LOCK, isSafari } from '../constants/constants';

let scrollbarWidth = 0;

export const isDomLoaded = (callBack: () => void) => {
  document.addEventListener('DOMContentLoaded', callBack);
};

export const checkWebPSupport = () => {
  return new Promise((resolve) => {
    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const img = new Image();

    img.onload = function() {
      resolve(true);
    };

    img.onerror = function() {
      resolve(false);
    };

    img.src = webpData;
  });
}

export const enableBodyScrollLock = () => document.body.classList.add(BODY_CLASS_SCROLL_LOCK);

export const disableBodyScrollLock = () => document.body.classList.remove(BODY_CLASS_SCROLL_LOCK);

export const getScrollTop = () => (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

export const setClassOutlineOnBody = () => {
  document.body.classList.add('no-outline');
};

export const removeClassOutlineOnBody = () => {
  document.body.classList.remove('no-outline');
};

export const getScrollbarWidth = () => {
  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  let scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  if (outer && outer.parentNode) {
    outer.parentNode.removeChild(outer);
  }
  // Removing temporary elements from the DOM
  return scrollbarWidth;
};

export const checkIfBodyHasScrollableContent = () => {
  const hasVerticalScrollbar = document.body.scrollHeight > window.innerHeight;

  return hasVerticalScrollbar;
}

export const setScrollbarWidth = () => {
  const currentScrollbarWidth = getScrollbarWidth();
  scrollbarWidth = checkIfBodyHasScrollableContent() ? currentScrollbarWidth : 0;
  document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

export const isSafariByVersionAndBelow = (version: number) => {
  if (isSafari) {
    const safariVersionMatch = navigator.userAgent.match(/Version\/([0-9]*.[0-9]*)/);
    const safariVersion = safariVersionMatch ? parseFloat(safariVersionMatch[1]) : 0;

    if (safariVersion <= version) {
      return true
    }

    return false;
  }
  return false;
};

export const getCustomCssProperty = (el: HTMLElement, propertyName: string) => getComputedStyle(el).getPropertyValue(propertyName);

export const selectTextFromHtmlNode = (targetSelector: string) => {
  const target = document.querySelector(targetSelector);
  if (window.getSelection && target) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(target);
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
    } else {
      console.error('No selection available');
    }
  } else {
    alert('Could not copy into clipboard');
  }
};
